import ScrollToogle from './scrollToogle';

export * from './scrollToogle';

export default ScrollToogle;
